import { ComponentRequest, GlobalResponse } from '~/models/Commons ';
import { api } from '../api';
import { COMPONENTS} from '../endpoints';
import { SET_COMPONENTS } from '~/store/feature/Components';

const extendedApiSlice = api.injectEndpoints({
  endpoints: builder => ({
    getComponents: builder.query<
      GlobalResponse<any[]>,
      { page: number; size: number; active: boolean,type:string }
    >({
      query: ({ page, size, active,type }) => ({
        url: `${COMPONENTS}?page=${page}&size=${size}&&active=${active}&type=${type}`,
        method: 'GET',
        credentials: 'include',
        headers: {
          Authorization: sessionStorage.getItem('access_token')
            ? `Bearer ${sessionStorage.getItem('access_token')}`
            : ``,
        },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(SET_COMPONENTS(data.payload));
        } catch (error) {
          console.error('Error fetching scripts:', error);
        }
      },
    }),
    saveComponents: builder.mutation<GlobalResponse<ComponentRequest>, ComponentRequest>({
      query: (data) => {
        const token = sessionStorage.getItem('access_token');
        if (!token) {
          throw new Error('No access token found');
        }
    
        return {
          url: COMPONENTS, 
          method: 'POST',
          body: data,
          credentials: 'include',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        };
      },
    }),
  }),
});

export const {
  useSaveComponentsMutation,
  useGetComponentsQuery,
  useLazyGetComponentsQuery,
} = extendedApiSlice;